// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_OVERVIEW = '/top';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_GENERAL = '/top';
const ROOTS_HISTORY = '/history';
const ROOTS_MASTER = '/master';

// ----------------------------------------------------------------------
export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  account: path(ROOTS_DASHBOARD, '/account'),
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  // MFA対応 start --------------
  selectMfaMethod: path(ROOTS_AUTH, '/select-mfa-method'),
  addTotpDevice: path(ROOTS_AUTH, '/add-totp-device'),
  // MFA対応 end --------------
};

export const PATH_PAGE = {
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_GENERAL = {
  root: ROOTS_GENERAL,
};

export const PATH_HISTORY = {
  root: ROOTS_HISTORY,
};

export const PATH_MASTER = {
  root: ROOTS_MASTER,
};

export const PATH_OVERVIEW = {
  root: ROOTS_OVERVIEW,
  overview: path(ROOTS_OVERVIEW, ''),
};
